import { createSlice } from '@reduxjs/toolkit';
import { recoverOneK8byOrderID } from '../actions/k8Actions';

const initialState = {
  isLoading: false,
  error: null,
  allOneKeCluster: [],
  addOneKe: {},
  deleteOneKe: {},
  recoverKe: {},
  retireOneKe: {},
  syncKeClusters: {},
  oneKeDetails: {},
  selectedOneKeDetails: {},
  customerK8Clusters: {},
  oneKeQuota: {},
  remainingQuota: {},
  selectedOneKe: {},
};

const oneServerSlice = createSlice({
  name: 'kubernetes',
  initialState,
  reducers: {
    start: (state, action) => {
      state.error = null;
      state.isLoading = true;
    },
    setReducerError: (state, action) => {
      state.error = action.error;
      state.isLoading = false;
    },
    setAllOneKeClusters: (state, action) => {
      state.allOneKeCluster = action.payload;
      state.isLoading = false;
    },
    setAddOneKe: (state, action) => {
      state.addOneKe = action.payload;
      state.isLoading = false;
    },
    setDeleteOneKe: (state, action) => {
      state.deleteOneKe = action.payload;
      state.isLoading = false;
    },
    setRetireOneKe: (state, action) => {
      state.retireOneKe = action.payload;
      state.isLoading = false;
    },
    getOneKeDetails: (state, action) => {
      state.oneKeDetails = action.payload;
      state.isLoading = false;
    },
    setSelectedOneKe: (state, action) => {
      state.selectedOneKe = action.payload;
      state.isLoading = false;
    },
    getSelectedOneKeDetails: (state, action) => {
      state.selectedOneKeDetails = action.payload;
      state.isLoading = false;
    },
    recoverOneKe: (state, action) => {
      state.recoverKe = action.payload;
      state.isLoading = false;
    },
    setSyncKeClusters: (state, action) => {
      state.syncKeClusters = action.payload;
      state.isLoading = false;
    },
    setCustomerOneKeClusters: (state, action) => {
      state.customerK8Clusters = action.payload;
      state.isLoading = false;
    },
    setOneKeQuota: (state, action) => {
      state.oneKeQuota = action.payload;
      state.isLoading = false;
    },
    setRemainingQuota: (state, action) => {
      state.remainingQuota = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  start,
  setReducerError,
  setSyncKeClusters,
  setAllOneKeClusters,
  setAddOneKe,
  setDeleteOneKe,
  getOneKeDetails,
  getSelectedOneKeDetails,
  setRetireOneKe,
  recoverOneKe,
  setCustomerOneKeClusters,
  setOneKeQuota,
  setRemainingQuota,
  setSelectedOneKe,
} = oneServerSlice.actions;

export default oneServerSlice.reducer;
